import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class BankAccount {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  officeId!: string;
  @IsString()
  @Expose()
  bankName!: string;
  @IsOptional()
  @IsString()
  @Expose()
  swift!: string;
  @IsString()
  @Expose()
  accountNumber!: string;
  @IsOptional()
  @IsString()
  @Expose()
  iban!: string;
  @IsOptional()
  @IsString()
  @Expose()
  accountCurrency!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  accountParserId!: number | null;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string;
  @IsOptional()
  @IsString()
  @Expose()
  registerSymbol!: string;
  @IsOptional()
  @IsString()
  @Expose()
  exportSymbol!: string;
  @IsOptional()
  @IsString()
  @Expose()
  exportAccount!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  isDefault!: boolean;
  @IsBoolean()
  @Expose()
  isAssigned!: boolean;
  @IsBoolean()
  @Expose()
  isDeleted!: boolean;
  @IsBoolean()
  @Expose()
  disableExport!: boolean;
  @IsString()
  @IsOptional()
  @Expose()
  contractorId?: string;
  @IsString()
  @IsOptional()
  @Expose()
  contractorName?: string;
  @IsNumber()
  @Expose()
  recordStampId?: number;
}

export class BankAccountAddEdit {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  officeId!: string;
  @IsString()
  @Expose()
  bankName!: string;
  @IsString()
  @Expose()
  swift!: string;
  @IsString()
  @Expose()
  accountNumber!: string;
  @IsOptional()
  @IsString()
  @Expose()
  iban!: string;
  @IsOptional()
  @IsString()
  @Expose()
  accountCurrency!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  accountParserId!: number | null;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string;
  @IsString()
  @Expose()
  registerSymbol!: string;
  @IsString()
  @Expose()
  exportSymbol!: string;
  @IsString()
  @Expose()
  exportAccount!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  isDefault!: boolean;
  @IsBoolean()
  @Expose()
  isAssigned!: boolean;
  @IsBoolean()
  @Expose()
  isDeleted!: boolean;
  @IsBoolean()
  @Expose()
  disableExport!: boolean;

  constructor();
  constructor(bankModel: BankAccount);
  constructor(bankModel?: BankAccount) {
    this.id = bankModel ? bankModel.id : -1;
    this.bankName = bankModel ? bankModel.bankName : "";
    this.swift = bankModel ? bankModel.swift : "";
    this.iban = bankModel ? bankModel.iban : "";
    this.accountNumber = bankModel ? bankModel.accountNumber : "";
    this.accountCurrency = bankModel ? bankModel.accountCurrency : "";
    this.description = bankModel ? bankModel.description : "";
    this.accountParserId = bankModel ? bankModel.accountParserId : -1;
    this.disableExport = bankModel ? bankModel.disableExport : false;
    this.registerSymbol = bankModel ? bankModel.registerSymbol : "";
    this.exportSymbol = bankModel ? bankModel.exportSymbol : "";
    this.exportAccount = bankModel ? bankModel.exportAccount : "";
    this.isAssigned = bankModel ? bankModel.isAssigned : false;
    this.isDefault = bankModel ? bankModel.isDefault : false;
    this.isDeleted = bankModel ? bankModel.isDeleted : false;
    this.isLocked = bankModel ? bankModel.isLocked : false;
    this.officeId = bankModel ? bankModel.officeId : "00000000-0000-0000-0000-000000000000";
  }
}

export class BankAccountOfficeProfileRequest {
  @IsNumber()
  @Expose()
  bankAccountId!: number;
  @IsNumber()
  @Expose()
  officeProfileId!: number;
}

export class BankAccountResponse extends GenericTableResponse<BankAccount> {
  @Type(() => BankAccount)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BankAccount>;
}
